export default __webpack_public_path__ + "static/blob1-5580fd846efb5dde841ff6acb8b3f5f2.svg";